import React from 'react'

// import {Api} from '../../libs/api'

class NoLogin extends React.Component {
    render() {
        // if (Api.getLogin())
        return (
            <tr>
                <td colSpan="7">
                    <div className="list-body_notfound">
                        상품견적에 담긴 상품이 없습니다.
                        <p>로그인 후 상품견적에 담긴 상품을 확인할 수 있습니다.</p>
                        {/*eslint-disable-next-line*/}
                        <a className="btn_shopping">로그인 하기</a>
                    </div>
                </td>
            </tr>
        )
    }
}

class NoItems extends React.Component {
    onMoveEstimate() {
        this.props.onMoveEstimate()
    }

    render() {
        return (
            <tr style={{ borderBottom: '2px solid #333' }}>
                {this.props.itemListLoading ? (
                    <td colSpan="7" style={{ paddingBottom: '70px' }}>
                        <div className="list-body_notfound">
                            견적에 담긴 상품이 없습니다.
                            {/*eslint-disable-next-line*/}
                            <a className="btn_shopping" onClick={() => this.onMoveEstimate()}>
                                견적 작성하기
                            </a>
                        </div>
                    </td>
                ) : (
                    <td colSpan="7" style={{ paddingBottom: '222px' }}>
                        <div className="list-body_notfound"></div>
                    </td>
                )}
            </tr>
        )
    }
}

// export Error;
export { NoLogin, NoItems }



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/error.js